/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import AbstractFieldGroup from './AbstractFieldGroup';

export default class Link extends AbstractFieldGroup {
	fields() {
		return [
			{
				name: 'url',
				type: 'text',
			},
			{
				name: 'label',
				type: 'text',
			},
			{
				name: 'new_tab',
				type: 'switch',
			},
			{
				name: 'is_external',
				type: 'switch',
			},
		];
	}
}
